export const AVAILABLE_LOCALES = ["en"] as const
export type AvailableLocale = (typeof AVAILABLE_LOCALES)[number]

export const DEFAULT_LOCALE: AvailableLocale = "en" as const
